import React from "react";
import {useUrlFilterState} from "../../../../infecto-lms-admin/components/core/filters/useUrlFilterState";

export interface AnswersStatisticsFilterState {
    filterByTitle?: string;
    greaterThanDate?: string;
    lessThanDate?: string;
    filterByTagIds?: string[] | null;
}

interface Search {
    filters:AnswersStatisticsFilterState;
    setFilters: (filters: AnswersStatisticsFilterState) => void;
    clearFilters: () => void;
}

export const AnswersStatisticsSearchContext = React.createContext<Search>({
    setFilters: () => {},
    clearFilters: () => {},
    filters: {},
});

interface OwnProps {
    children: any;
}

export const AnswersStatisticsSearchContainer = ({ children }: OwnProps) => {
    const { state, setState } = useUrlFilterState<AnswersStatisticsFilterState>();

    return (
        < AnswersStatisticsSearchContext.Provider
            value={{
                filters: state,
                setFilters: (filters) => {
                    setState(filters);
                },
                clearFilters: () => {
                    setState({});
                },
            }}
        >
            {children}
        </ AnswersStatisticsSearchContext.Provider>
    );
};
